import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Pharmacy APIs
//TODO: Pharmacy APIs
//  Pharmacy Create
export const listPharmacyAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.get(`${BASE_URL}list-pharmacy`,  headers);
};
// export const listPharmacyTelecaller = async (data) => {
//   const headers = createHeaders()   
//   return await axios.get(`${BASE_URL}order-flow`,  headers);
// };


export const listPharmacyTelecaller = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}order-flow`,   data,  headers);
};
export const confirmOrderAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}confirm-order`,   data,  headers);
};
export const confirmOrderSplit = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}confirm-order-split`,   data,  headers);
};
//  Pharmacy Update
export const updatePharmacyAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-pharmacy`, data, headers);
};
//  Pharmacy Details
export const pharmacyDetailsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}pharmacy-detail-admin`,   data,  headers);
};
//  Pharmacy Review
export const reviewPharmacyAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}review-pharmacy-admin`,   data,  headers);
};

//  Pharmacy Dashboard Orders
export const pharmacyDashboardOrdersAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}pharmacy-dashboard-orders`,   data,  headers);
};
export const ratingReviewAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}rating-review`,   data,  headers);
};
export const sideBarAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}sidebar`,   data,  headers);
};
//  Pharmacy Dashboard 
export const pharmacyDashboardAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}pharmacy-dashboard`,   data,  headers);
};

export const labDashboardAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-dashboard`,   data,  headers);
};

//  Pharmacy Dashboard 
export const getOrdersDetailsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}order-details-admin`,   data,  headers);
};

export const labOrderListAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-order-list-admin`,   data,  headers);
};
export const labOrderListDetailsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-order-detail`,   data,  headers);
};
export const updateSampleStatusAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-sample-status`,   data,  headers);
};
 
//  Pharmacy Dashboard 
export const cancelOrderApi = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}cancel-order-admin`,   data,  headers);
};
//  Pharmacy Dashboard 
export const updateOrderStatusAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-order-status`,   data,  headers);
};
 export const createPharmacyBoy = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}add-pharmacy-boy`,data,headers);
};

 export const pharmacyBoyList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}pharmacy-boy-list`,data,headers);
};
 export const updatePharmacyBoy = async (data) => {
  const headers = createHeaders()  
  return await axios.post(`${BASE_URL}update-pharmacy-boy`, data, headers);
};

export const telecallerOrderList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}telecaller-order-list`,   data,  headers)
};

export const updateOrder = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-order`,   data,  headers)
};
export const searchMedicine = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}search-medicine`,   data,  headers)
};
export const updateRadius = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-radius`,   data,  headers)
};
export const deliveredOrderVerifyAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}delivered-order-verify`,   data,  headers);
};

export const updatePharmacy = async (formdata) => {
  const headers = createHeaders();

  return await axios.post(
    `${BASE_URL}update-pharmacy-edit`,
    formdata,
    {
      ...headers,
      headers: {
        ...headers.headers,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};